import React, { Component, Dispatch, ErrorInfo, ReactNode } from 'react';
import { Log } from 'ng2-logger';
import { IAction, IAppState } from '../../models/action/core';
import { connect } from 'react-redux';
import App from '../../App';
import { IAppErrorProps, IAppProps } from '../../models/pages/app';
import * as CorePageAction from '../../store/actions/core';
import ApiClient from '../../api/alms-api';

const _logger = Log.create('ErrorBoundary.tsx');
const _api = new ApiClient();

export default class ErrorBoundary extends React.Component<IAppErrorProps> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  // public componentDidCatch(error: Error, errorInfo: ErrorInfo) {

  //   const exceptionMessage = {
  //     reactErrorName: error.name,
  //     reactErrorMessage: error.message,
  //     reactErrorStack: error.stack,
  //     reactComponentStack: errorInfo.componentStack,
  //     applicationType: 'ReactAlmsPlus',
  //     message: error.message
  //   };

  //   _api.insertGraylogMessage((this.props.userId ? this.props.userId : ''), (this.props.userName ? this.props.userName : ''), exceptionMessage);
  // }

  render() {
    // if (this.state.hasError) {
    //   // İstediğiniz herhangi bir son çare arayüzünü render edebilirsiniz.      
    //   return <h1>Something went wrong.</h1>;
    // }

    return this.props.children;
  }
}

const mapStateToProps = (state: any, ownProps: IAppErrorProps): IAppErrorProps => {
  if (!state) {
    return ownProps;
  }
  const returnProps: IAppErrorProps = Object.assign({}, ownProps, {
    userId: state.login.identitiy.userId,
    userName: state.login.identitiy.fullName
  });

  return returnProps;
};

// const dispatchProps = (dispatch: Dispatch<IAction>) => {
//   return {
//     dispatch
//   };
// };

// const CErrorBoundary = connect(
//   mapStateToProps,
//   dispatchProps
// )(ErrorBoundary);

// export default CErrorBoundary;